// Generated by @nuxtjs/svg-sprite
export const sprites = {
  "icons": () => import("/app/assets/sprite/gen/icons.svg").then(r => r.default || r)
}
export const spriteClass = "";

export const spriteClassPrefix = "";

export const defaultSprite = "icons";
